import { DOUBLELIFT_BANNER } from "./ad-banner.constants"
import { GAME_KEYS } from "@/store/game/game.constants"

const state = {}
const getters = {
  getBannerInfo: (state, getters, rootState, rootGetters) => {
    const userActiveGame = rootGetters["User/currentActiveGame"] || null
    const isUserPro = rootGetters["User/isUserPro"] || false
    const optimizelyData = rootGetters["Optimizely/optimizelyData"] || {}
    const isOptimizelyFeatureActive = !!optimizelyData.pay_to_unlock
    if (isOptimizelyFeatureActive && userActiveGame === GAME_KEYS.LEAGUE_OF_LEGENDS && !isUserPro) {
      return DOUBLELIFT_BANNER
    }
    return null
  },
}
const mutations = {}
const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/ad-banner/ad-banner.module.js